import moment from 'moment';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    sortedIds: []
});

export default (state = getInitialState(), action) => {
    let newById;
    let survey;
    let reduced;
    switch (action.type) {
        case ACTIONS.PUT_SURVEY_SUCCESS:
        case ACTIONS.POST_SURVEY_SUCCESS:
        case ACTIONS.GET_SURVEY: {
            ({ survey } = action.payload);
            newById = {
                ...state.byId,
                [survey._id]: survey
            };
            return {
                ...state,
                byId: newById,
                sortedIds: Object.keys(newById).sort((a, b) =>
                    moment.utc(newById[a].createdOn).diff(moment.utc(newById[b].createdOn))
                )
            };
        }
        case ACTIONS.GET_MANY_SURVEYS: {
            reduced = action.payload.surveys.reduce((prev, survey) => {
                prev[survey._id] = survey;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById,
                sortedIds: Object.keys(newById).sort((a, b) =>
                    moment.utc(newById[a].createdOn).diff(moment.utc(newById[b].createdOn))
                )
            };
        }
        default:
            return state;
    }
};
